import isEqual from "lodash/isEqual";
import { Action, SubsidiaryModeAlert } from "PFApp/components/subsidiary_mode_alert";
import { Flex } from "PFComponents/containers";
import { NotificationSetting } from "PFTypes";
import { useTranslation } from "react-i18next";

import css from "./bulk_select_overlay.module.scss";

type BulkSelectOverlayProps = {
  selectedSettings: NotificationSetting[];
  onClose: VoidFunction;
  onEdit: VoidFunction;
};

const haveSameFrequencyOptions = (settings: NotificationSetting[]): boolean => {
  if (!settings.length) {
    return false;
  }

  const first = settings[0].frequencyOptions;
  return settings.every(({ frequencyOptions }) => isEqual(frequencyOptions, first));
};

export const BulkSelectOverlay = ({ selectedSettings, onClose, onEdit }: BulkSelectOverlayProps) => {
  const { t } = useTranslation();
  const { t: tNotificationsSettings } = useTranslation("notificationsSettings");

  const canEdit = haveSameFrequencyOptions(selectedSettings);

  const actions: Action[] = [
    {
      icon: "edit",
      ariaLabel: t("edit"),
      disabled: !canEdit,
      title: canEdit ? undefined : tNotificationsSettings("bulkEditDisabled"),
      onClick: onEdit
    }
  ];

  return (
    <Flex justifyContent="center" className={css.container}>
      <div className={css.background} />
      <SubsidiaryModeAlert
        className={css.alert}
        title={t("countSelected", { count: selectedSettings.length })}
        onClose={onClose}
        actions={actions}
      />
    </Flex>
  );
};
